export default [
    {
        key: 'actions',
        label: ''
    }
]



// WEBPACK FOOTER //
// ./src/assets/js/columns/replenishmentPlans.js